import Ajax from '@/lib/ajax'

export class UpdateRefundApplyDto {
  isReturnShippingFee?: boolean
  refundAmount: number
  shippingAddress?: ShippingAddressDto
  remark?: string
  applyStatus: number
}

export class ShippingAddressDto {
  name: string
  phone: string
  province: string
  city: string
  district: string
  address: string
  zipCode: string
}

export default {
  /**
   * 获取退款申请列表
   * @param pageSize
   * @param currentPage
   */
  getrefundList(
    pageSize: number,
    currentPage: number,
    keyWord?: string,
    creationTime?: string,
    applyStatus?: number,
    Sorting?: string
  ) {
    let params = {
      keyWord: keyWord,
      creationTime: creationTime,
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      Sorting,
    }

    if (applyStatus != null) {
      params['applyStatus'] = applyStatus
    }
    return Ajax.get('/api/OrderManagement/refundapply', {
      params: params,
    })
  },

  /**
   * 获取退款申请
   * @param id
   */
  getRefundDetail(id: string) {
    return Ajax.get(`/api/OrderManagement/refundapply/${id}`)
  },

  /**
   * 更新退款申请单信息
   * @param id
   * @param updateRefundApply
   */
  updateRefundapply(id: string, updateRefundApply: UpdateRefundApplyDto) {
    return Ajax.put(`/api/OrderManagement/refundapply/${id}`, updateRefundApply)
  },

  /**
   * 更新退款单状态
   * @param id
   * @param refundApplyStatus
   * 0 待处理 1 处理中 2 已完成 3 已拒绝
   */
  updateRefundStatus(
    id: string,
    refundApplyStatus: number,
    remark?: string,
    expressCompanyName?: string,
    shipmentNumber?: string
  ) {
    return Ajax.put(`/api/OrderManagement/refundapply/applystatus/${id}`, {
      refundApplyStatus: refundApplyStatus,
      remark: remark,
      expressCompanyName: expressCompanyName,
      shipmentNumber: shipmentNumber,
    })
  },
  /**
   * 确认收货
   * @param id
   */
  returnReceived(id: string) {
    return Ajax.put(`/api/OrderManagement/refundapply/ReturnReceived/${id}`)
  },
  /**
   *  获取退款备注列表
   * @param id
   */
  getRefundNoteList(id: string) {
    return Ajax.get(`/api/OrderManagement/refundapply/Note/${id}`)
  },

  /**
   * 获取退款原因列表
   * @param pageSize
   * @param currentPage
   */
  getRefundReasonList(pageSize: number, currentPage: number) {
    return Ajax.get(`/api/OrderManagement/refundreason`, {
      params: {
        MaxResultCount: pageSize,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      },
    })
  },

  /**
   * 更新退款原因
   */
  updateRefundReason(
    name: string,
    displayOrder: number,
    published: boolean,
    id?: number
  ) {
    let url = '/api/OrderManagement/refundreason'
    if (id) {
      url += '/' + id
    }
    let ajaxType = id ? 'put' : 'post'
    return Ajax[ajaxType](url, {
      name: name,
      displayOrder: displayOrder,
      published: published,
    })
  },

  /**
   * 批量删除退款原因
   */
  deleteRefundReason(ids: number[]) {
    let list = ids || []
    let params = ''
    list.forEach((item, index) => {
      if (index === 0) {
        params = '?'
      }
      params += 'ids=' + item
      if (index < list.length - 1) {
        params += '&'
      }
    })
    return Ajax.delete(`/api/OrderManagement/refundreason${params}`)
  },
  /**
   * 获取管易退货单号
   * @param returnOrderNo 服务单号
   */
  getErpReturnOrder(returnOrderNo: string) {
    return Ajax.get(`/api/GuanYiErpManagement/erpReturnOrder/${returnOrderNo}`)
  },
  /**
   * 更新管易退货单号
   */
  updateErpReturnOrder(id: string, externalCode: string) {
    return Ajax.put(
      `/api/GuanYiErpManagement/erpReturnOrder/${id}?externalCode=${externalCode}`
    )
  },
  /**
 * 帮填退货快递单号
 */
  shipment(id: string, params: object) {
    return Ajax.put(
      `/api/OrderManagement/public/refundapply/shipment/${id}`, params)
  }
}
